import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapSidebarGroupHeaderComponent } from './map-sidebar-group-header.component';



@NgModule({
  declarations: [MapSidebarGroupHeaderComponent],
  imports: [
    CommonModule
  ],
  exports: [MapSidebarGroupHeaderComponent]
})
export class MapSidebarGroupHeaderModule { }
